var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "guest-form-container form-container" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "contact-form" }, [
      _c(
        "div",
        {
          staticClass: "contact-field",
          class: _vm.validateClass(_vm.hasValidName(_vm.guestNameModel))
        },
        [
          _c("BaseIcon", {
            staticClass: "input-field-icon",
            attrs: { icon: "userEdit", size: "1x" }
          }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.guestNameModel,
                expression: "guestNameModel"
              }
            ],
            staticClass: "input text-input has-icon",
            attrs: { type: "text", placeholder: "Name" },
            domProps: { value: _vm.guestNameModel },
            on: {
              blur: function($event) {
                return _vm.updateName()
              },
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.guestNameModel = $event.target.value
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "contact-field", class: _vm.updatePhoneClass() },
        [
          _c("BaseIcon", {
            staticClass: "input-field-icon",
            attrs: { icon: "phone", size: "1x" }
          }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.phone,
                expression: "phone"
              }
            ],
            staticClass: "input text-input has-icon",
            attrs: { type: "tel", placeholder: "Phone (607) 123 4567" },
            domProps: { value: _vm.phone },
            on: {
              blur: function($event) {
                return _vm.updatePhone()
              },
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.phone = $event.target.value
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "terms-wrapper" }, [
        _c(
          "label",
          {
            ref: "leaveAtDoorCheckbox",
            staticClass: "control control--checkbox cust-radio"
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.acceptTerms,
                  expression: "acceptTerms"
                }
              ],
              attrs: {
                type: "checkbox",
                role: "checkbox",
                "aria-label": "accept terms of service"
              },
              domProps: {
                checked: Array.isArray(_vm.acceptTerms)
                  ? _vm._i(_vm.acceptTerms, null) > -1
                  : _vm.acceptTerms
              },
              on: {
                change: function($event) {
                  var $$a = _vm.acceptTerms,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.acceptTerms = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.acceptTerms = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.acceptTerms = $$c
                  }
                }
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "control__indicator checkbox" }),
            _vm._v(" "),
            _vm._m(1)
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "contact-form" },
        [
          _c("BaseButton", {
            attrs: {
              classNames: ["button--modifier", "input-field-button"],
              title: "Continue",
              type: "scaleable-fixed-square",
              disabled: !_vm.validateAccount() || !_vm.acceptTerms
            },
            on: { click: _vm.handleClickContinue }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "small-link",
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm._navigateToSignIn($event)
            }
          }
        },
        [_vm._v("or sign in with an account")]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "center-message" }, [
      _c("p", [_vm._v("Continue order as a guest?")]),
      _vm._v(" "),
      _c("p", [_vm._v("Please enter your details:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "is-size-7" }, [
      _vm._v("\n\t\t\t\t\tI agree to the "),
      _c(
        "a",
        {
          staticClass: "red-link",
          attrs: { target: "_blank", href: "https://www.touchpoint.io/terms" }
        },
        [_vm._v("Terms of Service")]
      ),
      _vm._v(". Learn about how we use and protect your data in our "),
      _c(
        "a",
        {
          staticClass: "red-link",
          attrs: { target: "_blank", href: "https://www.touchpoint.io/privacy" }
        },
        [_vm._v("Privacy Policy")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d5e41f4c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5e41f4c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/GuestForm.vue
// module id = null
// module chunks = 